import Glide from '@glidejs/glide';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

//slider de talleres
var workshopSlider = new Glide('.section3a__slider', {
    type: 'carousel',
    startAt: 0,
    perView: 2.75,
    swipeThreshold: false,
    dragThreshold: false,
    breakpoints: {
        991: {
            perView: 1.75,
        },
        768: {
            perView: 1,
        },
    },

}).on('move', () => {
    let currentIndex;
    if (workshopSlider.index === 6){
        if (screen.width <= 991){
            if (document.querySelector('.section3a__item') != null) {
                currentIndex = 14;
            }else {
                currentIndex = 0;
            }
        }else{
            if (document.querySelector('.section3a__item') != null) {
                currentIndex = 2;
            }else {
                currentIndex = 0;
            }
        }
    }else {
        if (document.querySelector('.section3a__item') != null) {
            currentIndex = workshopSlider.index * 2 + getVisibleSlides();
        }else{
            currentIndex = 0;
        }
    }
    document.querySelector('.workshop__current-slide').textContent = currentIndex;
});
workshopSlider.mount();

//numero de sliders visibles en el slider de los talleres
function getVisibleSlides() {
    const containerWidth = document.querySelector('.glide__track').offsetWidth;
    if (document.querySelector('.section3a__item') != null){
        const slideWidth = document.querySelector('.section3a__item').offsetWidth;
        // Número de slides visibles (se redondea hacia abajo para obtener el entero)
        const visibleSlides = Math.floor(containerWidth / slideWidth);
        return visibleSlides*2;
    }
}


//scroll de tarjetas y queda fija la sección del sorteo
let mm = gsap.matchMedia();
mm.add(
    "(min-width:1200px)",() => {
        gsap.to(".section3b", {
            scrollTrigger: {
                trigger: ".section3b",
                start: "top 100px",
                end: "+=3000",
                pin: true,               // Mantiene el contenedor "fijo"
                pinSpacing: false,        // Evita que el espacio extra se añada después del "pin"
            }
        });
//hacer que los cards dentro de la sección del sorteo se desplazen
        gsap.to('.section3b__card1', {
            scrollTrigger: {
                trigger: ".section3b__card1",
                start: "top-=100 top",
                end: "+=700",
                scrub: true,
                toggleClass: {targets: ".section3b__card1", className: "active"}
            }
        });
        gsap.to('.section3b__card2', {
            y: -230,
            scrollTrigger: {
                trigger: ".section3b__card2",
                start: "top+=300 top",
                end: "+=900",
                scrub: true,
                toggleClass: {targets: ".section3b__card2", className: "active"}
            }
        });
        gsap.to('.section3b__card3', {
            y: -550,
            scrollTrigger: {
                trigger: ".section3b__card3",
                start: "top+=600 top",
                end: "+=1500",
                scrub: true,
                toggleClass: {targets: ".section3b__card3", className: "active"}
            }
        });
    });

//slider de las ofertas de empleo
if ($('.section3c__slider').length){
    var jobOfferSlider = new Glide('.section3c__slider', {
        type: 'slider',
        /*startAt: 0,*/
        perView: 1,
        gap: 0,
        swipeThreshold: false,
        dragThreshold: false,

    }).mount();
}

